if (!customElements.get('ir-testimonials')) {
  class IRTestimonials extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.ir-testimonial'));
      this.dots = Array.from(this.querySelectorAll('.ir-testimonials__dot'));
      this.index = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (this.index < 0) this.index = 0;
      this.timer = null;
      this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1;
      this.speed = Number(this.dataset.speed || 6000);

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.goTo(Number(dot.dataset.index));
          this.restart();
        });
      });

      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.restart());
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', () => this.restart());

      document.addEventListener('visibilitychange', this.onVisibility);
      this.goTo(this.index, false);
      this.restart();
    }

    disconnectedCallback() {
      this.pause();
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    onVisibility = () => {
      if (document.hidden) this.pause();
      else this.restart();
    };

    goTo(nextIndex, animate = true) {
      if (!this.slides.length) return;
      const total = this.slides.length;
      this.index = ((nextIndex % total) + total) % total;

      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (animate) {
          slide.classList.toggle('is-animating', active);
        }
      });

      this.dots.forEach((dot, i) => {
        const active = i === this.index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    next = () => this.goTo(this.index + 1);

    pause() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    restart() {
      this.pause();
      if (!this.autoplay) return;
      this.timer = setInterval(this.next, this.speed);
    }
  }

  customElements.define('ir-testimonials', IRTestimonials);
}
